import{j as t}from"./chunk-V2DQWH6R.js";import{a as r}from"./chunk-DMS2IT2J.js";import{m as e}from"./chunk-HBP5N4FR.js";e();function f(){return t(r.getState())}export{f as a};
//# sourceMappingURL=chunk-M4CDK7EF.js.map
